<template>
<footer class="u-bg-color-secondary u-py-2">
      <p class="u-text-center u-text-color-w u-mb-0">©S.Vila 2022. Todos los derechos reservados.</p>
</footer>   
</template>